import { defineStore } from "pinia";
import { callApi } from "src/utils/apiRequestHandler";

export const useAltriaStore = defineStore("Altriastore", {
  state: () => ({
    altria_info: {},
    loadAltriaInfo: false,
  }),
  getters: {},
  actions: {
    resetAltriaStore() {
      this.altria_info = {};
      this.loadAltriaInfo = false;
    },

    //API: GET - api/v1/customer/stores/{storeId}/all-eaiv-status
    async getAllEaivStatusApi(storeid) {
      try {
        this.resetAltriaStore();
        const data = await this.$request.get(
          `${this.apiEndpoints.ALL_EAIV_STATUS(storeid)}?acc=${storeid}`
        );
        return data.data;
      } catch (error) {}
    },

    //API: GET - api/v1/customer/stores/{storeId}/survey-options
    async getsurveyOptionApi(storeid) {
      try {
        this.resetAltriaStore();
        const data = await this.$request.get(
          `${this.apiEndpoints.SURVAY_OPTION(storeid)}?acc=${storeid}`
        );
        if (data.data && data.data.status) {
          this.loadAltriaInfo = true;
          this.altria_info = data.data.item;
          return data.data;
        }
        return data.data;
      } catch (error) {}
    },

    //API: POST - api/v1/customer/stores/{storeId}/post-survey
    async submitsurveyOptionApi(storeid, params) {
      try {
        params.acc = storeid;
        let data = await this.$request.post(
          this.apiEndpoints.POST_SURVAY(storeid),
          params
        );
        if (data.data) {
          return data.data;
        }
      } catch (error) {}
    },

    //API: POST - api/v1/customer/stores/{storeId}/save-eaiv-status
    async submitEAIVSkipedStatusApi(storeid, params) {
      try {
        params.acc = storeid;
        let data = await this.$request.post(
          this.apiEndpoints.POST_SAVE_EAIV_STATUS(storeid),
          params
        );
        // if (data.data && data.data.status) {
        //   return true;
        // }
        return data.data;
      } catch (error) {
        return false;
      }
    },

    //API: POST - api/v1/customer/stores/{storeId}/disable-notification
    async submitNotificationApi(storeid, params) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.POST_SAVE_NOTIFICATION_STATUS(storeid),
          params
        );
        // if (data.data && data.data.status) {
        //   return true;
        // }
        return data.data;
      } catch (error) {
        return false;
      }
    },

    //API: POST - api/v1/customer/stores/{storeId}/eaiv-completed
    async submitEAIVAtatusApi(storeid, params) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.EAIV_COMPLETE_STATUS(storeid),
          params
        );
        // if (data.data && data.data.status) {
        //   return true;
        // }
        return data.data;
      } catch (error) {
        return false;
      }
    },
  },
});
